import React from 'react'
import { Image } from '../Image'

export const EmojiIcon = ({ src, size }: { src: string; size: string }) => {
  return <Image width={size} height={size} src={src} />
}
